module.exports = __webpack_public_path__ + "fonts/iconfont.81ce2808.woff2";